export default {
  企业云展评分描述: '得分越高，曝光率权重越高，赶紧去完善吧！',
  您的企业云展得分: '您的企业云展得分',
  信息编辑: '信息编辑',
  编辑预览我的企业云展: '编辑/预览我的企业云展',
  企业已禁用: '企业已禁用',
  加入该企业: '加入该企业',
  是否: '是否',
  当前企业已被认证: '当前企业已被认证',
  加入方式: '加入方式',
  受邀申请: '受邀申请',
  主动申请: '主动申请',
  企业基本信息: '企业基本信息',
  职务: '职务',
  '（必填）': '（必填）',
  '（选填）': '（选填）',
  语言版本: '语言版本',
  当前支持的语言版本: '当前支持的语言版本',
  简体中文: '简体中文',
  英文: '英文',
  中英文: '中英文',
  云展动力平台支持多语言版本显示提示语:
    '云展动力平台支持多语言版本显示,多语言版本的完善有助于企业获取潜在的不同国家的客户,有助于不同国家客户更方便了解您的企业。',
  英文未完成:
    '系统检测您已填写【英语】版本的部分字段,还没完成剩余必填的字段,是否继续提交？若继续提交,则该【英语】版本不会被保存,请知悉！',
  中文未完成:
    '系统检测您已填写【中文】版本的部分字段,还没完成剩余必填的字段,是否继续提交？若继续提交,则该【中文】版本不会被保存,请知悉！',
  申请角色提示1: '企业角色申请提交成功后,平台将于1-3个工作日进行审核,审核结果会以站内信消息通知,请留意；',
  申请角色提示2:
    '企业信息相关内容禁止发布涉及政治、色情、暴力、低俗等违法不良信息,一经发现平台将有权进行冻结您的账户,并保留追究法律责任；',
  申请角色提示3: '企业根据面向不同市场与自身所需,可选择补充其他语言版本的翻译内容,支持简体中文（默认）、英语；',
  申请角色提示4:
    '当前云展动力平台支持简体中文、英语语言,为了获取来自不同国家客户的兴趣与意向订单,强烈建议企业完善当前系统所支持的语言版本内容；',
  申请角色提示5: '至少完成一种语言的内容输入才可以成功提交,不可全部为空；',
  新浪微博: '新浪微博',
  填写企业资料: '填写企业资料',
  企业名称: '企业名称',
  城市: '城市',
  企业简介: '企业简介',
  企业宣传册: '企业宣传册',
  产品服务: '产品服务',
  企业展览: '企业展览',
  企业LOGO: '企业LOGO',
  公司简介: '公司简介',
  公司联系方式: '公司联系方式',
  业务联系信息: '业务联系信息',
  删除当前图片: '删除当前图片',
  点击上传LOGO: '点击上传LOGO',
  '公司认证(二选一)': '公司认证(二选一)',
  企业LOGO图片格式说明: '图片格式为JPG/PNG,建议底图为白色或透明,长宽的尺寸至少大于300px,大小5M以内',
  营业执照图片格式说明: '图片格式为JPG/PNG,白色底或透明度,大小不能超过10M',
  营业执照: '营业执照',
  营业执照原件: '营业执照原件',
  '请输入工商局注册的完整企业名称,120个字符以内': '请输入工商局注册的完整企业名称,120个字符以内',
  请输入企业官网: '请输入企业官网',
  请输入联系人: '请输入联系人',
  请输入联系手机号码: '请输入联系手机号',
  请输入联系邮箱: '请输入联系邮箱',
  请输入岗位: '请输入岗位',
  请选择3D类型: '请选择3D类型',
  请输入3D标题: '请输入3D标题',
  请输入3D链接: '请输入3D链接',
  请填写3D超链接: '请填写3D超链接',
  请上传3D封面图: '请上传3D封面图',
  请上传企业Logo: '请上传企业Logo',
  请上传营业执照: '请上传营业执照',
  请输入正确的手机号码: '请输入正确的手机号码！',
  请输入正确的邮箱地址: '请输入正确的邮箱地址',
  请输入正确的固定电话号码: '请输入正确的固定电话号码！',
  '请输入联系方式,手机号/固定电话至少填一个！': '请输入联系方式,手机号/固定电话至少填一个！',
  请输入个人作品官网: '请输入个人作品官网',
  '请输入工商局注册的完整公司名称,120个字符以内': '请输入工商局注册的完整公司名称,120个字符以内',
  '请输入详细地址,120个字符以内': '请输入详细地址,120个字符以内',
  '请输入公司的法人姓名,10个字符以内': '请输入公司的法人姓名,10个字符以内',
  请输入公司联系邮箱: '请输入公司联系邮箱',
  请输入统一社会信用代码: '请输入统一社会信用代码',
  请输入正确的统一社会信用代码: '请输入正确的统一社会信用代码！',
  请上传公司Logo: '请上传公司Logo',
  请填写企业注册资本: '请填写企业注册资本',
  请上传公司营业执照: '请上传公司营业执照',
  '请上传身份证,正面图片': '请上传身份证,正面图片',
  '请上传身份证,反面图片': '请上传身份证,反面图片',
  请上传公函文件: '请上传公函文件',
  请输入邮箱: '请输入邮箱',
  请输入正确的邮箱: '请输入正确的邮箱！',
  请输入身份证号码: '请输入身份证号码！',
  请输入正确的网址: '请输入正确的网址',
  请输入正确的身份证号码: '请输入正确的身份证号码！',
  请输入微信号: '请输入微信号',
  请输入真实姓名: '请输入真实姓名',
  请输入详细地址: '请输入详细地址',
  公司法人姓名: '公司法人姓名',
  请输入公司法人姓名: '请输入公司法人姓名',
  请输入公司简介: '请输入公司简介',
  请输入自我介绍: '请输入自我介绍',
  请输入正确的链接地址: '请输入正确的链接地址',
  请输入子账号: '请输入子账号',
  请输入查看者用户名: '请输入查看者用户名',
  请输入转发者用户名: '请输入转发者用户名',
  请输入点赞者用户名: '请输入点赞者用户名',
  请输入主动分享者用户名: '请输入主动分享者用户名',
  请输入企业动态内容: '请输入企业动态内容(4000字以内)',
  '2000个字符以内': '2000个字符以内',
  请输入企业注册时间: '请输入企业注册时间',
  请选择企业员工人数: '请选择企业员工人数',
  请输入11位纯数字手机号: '请输入11位纯数字手机号',
  '请输入联系邮箱,60个字符以内': '请输入联系邮箱,60个字符以内',
  '请填写合作企业名称,最多120个字符': '请填写合作企业名称,最多120个字符',
  '请填写链接,最多120个字符': '请填写链接,最多120个字符',
  '请填写联系人姓名,最多30个字符': '请填写联系人姓名,最多30个字符',
  '请填写认缴金额,最多12个字符': '请填写认缴金额,最多12个字符',
  '请填写纯数字,单位人民币': '请填写纯数字,单位人民币',
  请填写投资比例: '请填写投资比例',
  '请填写纯数字,最大100.00%,单位%': '请填写纯数字,最大100.00%,单位%',
  '请填写投资机构的企业名称,最多120个字符': '请填写投资机构的企业名称,最多120个字符',
  '请填写对外投资的企业名称,最多120个字符': '请填写对外投资的企业名称,最多120个字符',
  请填写上市的国家: '请填写上市的国家',
  请填写上市的交易机构: '请填写上市的交易机构',
  请填写主营产品: '请填写主营产品',
  请填写手机号或者固定电话: '请填写手机号或者固定电话',
  请填写正确的手机号码: '请填写正确的手机号码',
  请填写固定电话号码: '请填写固定电话号码',
  请选择: '请选择',
  请选择企业性质: '请选择企业性质',
  请选择企业所在地区: '请选择企业所在地区',
  请选择至少一项擅长展览行业: '请选择至少一项擅长展览行业',
  请选择至少一项擅长会议行业: '请选择至少一项擅长会议行业',
  请选择至少一项擅长设计类型: '请选择至少一项擅长设计类型',
  请选择至少一项擅长行业分类: '请选择至少一项擅长行业分类',
  请选择头条分类: '请选择头条分类',
  请选择头条行业: '请选择头条行业',
  请选择展厅模型分类: '请选择展厅模型分类',
  请选择展览行业: '请选择展览行业',
  请选择展览行业分类: '请选择展览行业分类',
  请选择会议行业分类: '请选择会议行业分类',
  请选择详细地区或输入关键字搜索: '请选择详细地区或输入关键字搜索',
  '请选择国别/国家/省份或地区/市或地区': '请选择国别/国家/省份或地区/市或地区',
  填写业务联系信息: '填写业务联系信息',
  联系人: '联系人',
  '手机号/固定电话': '手机号/固定电话',
  联系邮箱: '联系邮箱',
  岗位: '岗位',
  企业官网: '企业官网',
  '企业宣传视频（选填）': '企业宣传视频（选填）',
  服务商类型: '服务商类型',
  真实姓名: '真实姓名',
  身份证号码: '身份证号码',
  个人身份证正反面: '个人身份证正反面',
  公司法人身份证正反面: '公司法人身份证正反面',
  '身份证正面（人头）': '身份证正面（人头）',
  '身份证反面（国徽）': '身份证反面（国徽）',
  所在地址: '所在地址',
  '个人作品官网（选填）': '个人作品官网（选填）',
  自我介绍: '自我介绍',
  公司名称: '公司名称',
  公司LOGO: '公司LOGO',
  公司地址: '公司地址',
  认证申请公函: '认证申请公函',
  样本下载: '样本下载',
  公司联系邮箱: '公司联系邮箱',
  统一社会信用代码: '统一社会信用代码',
  '微信号（选填）': '微信号（选填）',
  感兴趣的展览: '感兴趣的展览',
  感兴趣的会议: '感兴趣的会议',
  感兴趣的资讯: '感兴趣的资讯',
  擅长展览行业: '擅长展览行业',
  擅长会议行业: '擅长会议行业',
  选择擅长行业或属性: '选择擅长行业或属性',
  基本资料: '基本资料',
  公司资料: '公司资料',
  添加企业3D信息: '添加企业3D信息',
  '企业3D（选填）': '企业3D（选填）',
  '3D类型': '3D类型',
  '3D标题': '3D标题',
  '3D链接': '3D链接',
  '3D封面图': '3D封面图',
  点击上传3D封面图: '点击上传3D封面图',
  请上传: '请上传',
  立即上传: '立即上传',
  已上传文件: '已上传文件',
  正在上传: '正在上传',
  上传成功: '上传成功',
  更新申请: '更新申请',
  立即申请: '立即申请',
  提交成功: '提交成功',
  返回会员中心: '返回会员中心',
  '只可以上传jpg/png 格式的图片': '只可以上传jpg/png 格式的图片',
  '请上传 300*300 尺寸以上图片,当前图片': '请上传 300*300 尺寸以上图片,当前图片',
  '请上传 450*450 尺寸以上图片,当前图片': '请上传 450*450 尺寸以上图片,当前图片',
  '请上传 500*500 尺寸以上图片,当前图片': '请上传 500*500 尺寸以上图片,当前图片',
  '图片解析失败,请确保图片是正确的': '图片解析失败,请确保图片是正确的',
  '图片大小不可以超过 2MB!': '图片大小不可以超过 2MB!',
  '图片大小不可以超过 5MB!': '图片大小不可以超过 5MB!',
  '图片大小不可以超过 10MB!': '图片大小不可以超过 10MB!',
  视频格式说明: '视频格式支持MP4,最大200M',
  视频大小不可以超过200MB: '视频大小不可以超过 200MB!',
  大小不可以超过200MB: '大小不可以超过 200MB!',

  只能上传mp4格式文件: '只能上传mp4格式文件！',
  再次确认资料提交提示: '请再次确认您所填写的资料无误,审核期间无法取消,请留意审核结果的消息通知',
  身份证照片说明: '身份证照片会严格按照国家法律法规进行保存,请放心上传',
  '固话号码,由7到8位数字组成': '固话号码,由7到8位数字组成',
  '选择您感兴趣的展览/会议/展厅模型/资讯': '选择您感兴趣的展览/会议/展厅模型/资讯',
  '10个字符以内,请如实填写': '10个字符以内,请如实填写',
  '18个字符以内,请如实填写': '18个字符以内,请如实填写',
  最多填写10个汉字: '最多填写10个汉字',
  最多填写16个字符: '最多填写16个字符',
  最多填写75个汉字: '最多填写75个汉字',
  最多填写500个汉字: '最多填写500个汉字',
  最多填写600个汉字: '最多填写600个汉字',
  最多填写800个汉字: '最多填写800个汉字',
  最多填写2000个汉字: '最多填写2000个汉字',
  最多填写1000个汉字: '最多填写1000个汉字',
  '200个字符以内': '200个字符以内',
  上传带有公司盖章的认证申请公函: '上传带有公司盖章的认证申请公函',
  上传企业的3D展示链接的提示: '上传企业的3D展示链接,可提升企业的经营形象,增信企业真实性,有利于获取海量意向订单',
  参展商认证申请成功提示1: '恭喜您！平台会在2-3个工作日进行审核,审核结果会以站内信进行推送,您可以留意站内信通知。',
  参展商认证申请成功提示2:
    '在审核期间,您也可以事先准备好产品发布的图文资料,审核通过后可以在会员中心-产品管理,立刻发布产品,获取更多曝光,增加采购的权重！',
  参展商认证申请成功提示3:
    '审核通过后,您也可以在会员中心-基础资料,修改企业信息,包括企业3D链接、上传企业视频、企业官网等',
  参展商认证编辑成功提示1:
    '恭喜您！平台会在2-3个工作日进行审核,审核结果会以站内信进行推送,您可以留意站内信通知,或个人中心的变化。',
  云展动力服务平台审核提示: '云展动力服务平台将2-3个工作日进行审核,根据审核需求,可能会电话确认,请保持手机畅通哦',
  // 企业云展
  '提示：您的企业云展系统已被平台禁用': '提示：您的企业云展系统已被平台禁用',
  违规原因如下: '违规原因如下:',
  云展动力服务平台审核中提示: '云展动力会在2-3个工作日审核完毕,审核结果会以站内信推送,请留意站内信通知',
  企业云展系统完善度: '企业云展系统完善度',
  您的企业云展系统得分: '您的企业云展系统得分',
  完善度分数: '分',
  超过了: '超过了',
  用户: '用户',
  企业被查看累计数: '企业被查看累计数',
  企业被转发累计数: '企业被转发累计数',
  主动分享累计数: '主动分享累计数',
  企业被点赞认同累计数: '企业被点赞认同累计数',
  企业子账号效果汇总: '企业子账号效果汇总',
  '员工转发/裂变的效果明细': '员工转发/裂变的效果明细',
  完善企业云展系统提示:
    '完善企业云展系统,有助于提升您的企业形象与实力彰显,让更多潜在的客户加深对您的企业全面了解,赶紧去完善吧！',
  预览: '预览',
  分享: '分享',
  企业信息: '企业信息',
  '企业名称/logo/营业执照/简介/官网/地址/视频简介': '企业名称/logo/营业执照/简介/官网/地址/视频简介',
  完成度: '完成度',
  继续完善: '继续完善',
  企业基础信息: '企业基础信息',
  企业工商信息: '企业工商信息',
  企业工商: '企业工商',
  '企业注册时间/注册资本/主营产品/员工数/企业性质/上市企业/世界500强企业/对外投资/投资机构':
    '企业注册时间/注册资本/主营产品/员工数/企业性质/上市企业/世界500强企业/对外投资/投资机构',
  企业内容展示: '企业内容展示',
  企业内容: '企业内容',
  '企业相册/企业荣誉/企业3D/合作伙伴': '企业相册/企业荣誉/企业3D/合作伙伴',
  企业联系信息: '企业联系信息',
  企业联系: '企业联系',
  '联系人/联系方式/社交媒体/微信公众号二维码/微信小程序二维码':
    '联系人/联系方式/社交媒体/微信公众号二维码/微信小程序二维码',
  // count企业云展统计
  动作类型: '动作类型',
  动作内容: '动作内容',
  查看来源: '查看来源',
  查看时间: '查看时间',
  浏览时长: '浏览时长',
  查看次数: '查看次数',
  转发来源: '转发来源',
  转发时间: '转发时间',
  转发次数: '转发次数',
  点赞来源: '点赞来源',
  点赞时间: '点赞时间',
  点赞次数: '点赞次数',
  查看者详情: '查看者详情',
  转发者详情: '转发者详情',
  点赞者详情: '点赞者详情',
  分享者详情: '分享者详情',
  企业点赞累计数: '企业点赞累计数',
  企业主动分享累计数: '企业主动分享累计数',
  查看者用户名: '查看者用户名',
  转发者用户名: '转发者用户名',
  点赞者用户名: '点赞者用户名',
  主动分享者用户名: '主动分享者用户名',
  主动分享者: '主动分享者',
  主动来源: '主动来源',
  今日: '今日',
  昨日: '昨日',
  近7日: '近7日',
  近30日: '近30日',
  主动分享数注解: '主动分享数,指的是企业的子账号主动分享企业云展系统的次数；',
  被转发数注解: '被转发数,指的是企业的子账号主动分享出去的企业云展系统被其他用户转发的次数；',
  被查看数注解: '被查看数,指的是企业的子账号分享出去或被其他用户转发出去的企业云展系统被查看的次数；',
  用户头像: '用户头像',
  '子账号（或主账号)': '子账号（或主账号)',
  主动分享数: '主动分享数',
  被转发数: '被转发数',
  被查看数: '被查看数',
  被查看用户数: '被查看用户数',
  已联系用户数: '已联系用户数',
  人均浏览时长: '人均浏览时长',
  联系率: '联系率',
  查看率: '查看率',
  截止昨日: '截止昨日',
  截止今日: '截止今日',
  被查看记录: '被查看记录',
  被转发记录: '被转发记录',
  被点赞记录: '被点赞记录',
  主动分享记录: '主动分享记录',
  未知身份游客: '未知身份游客',
  洽谈: '洽谈',
  游客: '游客',
  我撤回了一条消息: '我撤回了一条消息',
  对方撤回了一条消息: '对方撤回了一条消息',
  撤回: '撤回',
  已读: '已读',
  查看全部: '查看全部',
  查看者: '查看者',
  最新查看时间: '最新查看时间',
  最新查看来源: '最新查看来源',
  累计: '累计',
  累计查看次数: '累计查看次数',
  联系状态: '联系状态',
  已联系: '已联系',
  未联系: '未联系',
  转发者: '转发者',
  最新来源: '最新来源',
  最新转发来源: '最新转发来源',
  最新转发时间: '最新转发时间',
  累计转发次数: '累计转发次数',
  点赞者: '点赞者',
  最新点赞来源: '最新点赞来源',
  最新点赞时间: '最新点赞时间',
  累计点赞次数: '累计点赞次数',
  主动分享来源: '主动分享来源',
  主动分享次数: '主动分享次数',
  主动分享时间: '主动分享时间',
  发布企业动态: '发布企业动态',
  企业动态总浏览量: '企业动态总浏览量',
  企业动态总点赞量: '企业动态总点赞量',
  动态内容: '动态内容',
  '动态图片(选填)': '动态图片(选填)',
  动态图片上传格式提示1: '图片格式为JPG/PNG,长宽的尺寸建议均大于300px,大小10M以内',
  动态图片上传格式提示2: '最多可上传9张图片',
  动态内容不能为空: '动态内容不能为空！',
  添加动态成功: '添加动态成功',
  删除动态成功: '删除动态成功',
  上一步: '上一步',
  下一步: '下一步',
  确定提交: '确定提交',
  企业云展系统编辑提交提示: '恭喜您！平台会在2-3个工作日进行审核,审核结果会以站内信进行推送,您可以留意站内信通知。',
  // 企业名称: '企业名称',
  企业logo: '企业logo',
  预览图片: '预览图片',
  企业营业执照: '企业营业执照',
  营业执照上传要求提示1: '照片格式为jpg, png,大小10M以内',
  营业执照上传要求提示2: '此营业执照会在客户查询企业增信展示,请确保照片边框完整,字体清晰,亮度适中',
  营业执照上传要求提示3: '国外可以上传当地政府颁发的相关企业证明执照文件照片',
  '公司认证（二选一）': '公司认证（二选一）',
  法人身份证正反面: '法人身份证正反面',
  '二选一,企业法人身份证正反面或认证申请公函': '二选一,企业法人身份证正反面或认证申请公函',
  身份证正反面: '身份证正反面',
  企业简介提示: '请尽量全面描述企业的介绍,可以尝试从企业成立、发展、取得的成就等方面描述',
  企业地址: '企业地址',
  预览视频: '预览视频',
  删除当前视频: '删除当前视频',
  企业注册时间: '企业注册时间',
  企业注册资本: '企业注册资本',
  主营产品: '主营产品',
  企业员工数: '企业员工数',
  '请如实填写注册资本,单位：人民币（¥）': '请如实填写注册资本,单位：人民币（¥）',
  企业性质: '企业性质',
  上市企业: '上市企业',
  '若是上市企业,请完善上市的国家、上市交易机构名称+代码': '若是上市企业,请完善上市的国家、上市交易机构名称+代码',
  '例如美国-纳斯达克 AMZN,中国-深交所 SZJY': '例如美国-纳斯达克 AMZN,中国-深交所 SZJY',
  世界500强企业: '世界500强企业',
  是: '是',
  否: '否',
  所有: '所有',
  世界500强企业说明: '若是世界500强企业,可以选择“是”,反之则选择“否”',
  对外投资: '对外投资',
  投资比例: '投资比例',
  认缴金额: '认缴金额',
  暂无对外投资数据: '暂无对外投资数据',
  对外投资说明: '列出自己企业对外投资的企业,增加企业的经济投资实力',
  投资机构: '投资机构',
  暂无投资机构数据: '暂无投资机构数据',
  列出自己企业的股东机构: '列出自己企业的股东机构',
  投资机构的企业: '投资机构的企业',
  对外投资的企业: '对外投资的企业',
  投资机构的企业LOGO: '投资机构的企业LOGO',
  对外投资的企业LOGO: '对外投资的企业LOGO',
  // 投资比例: '投资比例',
  // 认缴金额: '认缴金额',
  万元: '万元',
  仅支持纯数字输入: '仅支持纯数字输入',
  对外投资企业名不能为空: '对外投资企业名不能为空',
  '信息有误或未填写,请检查': '信息有误或未填写,请检查',
  // 联系人: '联系人',
  先生: '先生',
  女士: '女士',
  联系方式: '联系方式',
  社交媒体: '社交媒体',
  微信公众号二维码: '微信公众号二维码',
  最多填写120个字符: '最多填写120个字符',
  企业相册: '企业相册',
  企业相册上传提示1: '最多可上传30张照片,支持JPG/JPGN/PNG格式,每张不超过10M；',
  企业相册上传提示2: '推荐上传关于企业办公环境、仓库、展厅、车间,也可以上传员工团建等照片；',
  企业荣誉: '企业荣誉',
  企业荣誉上传提示1: '最多可上传15张照片,支持JPG/JPGN/PNG格式,每张不超过10M；',
  点击添加: '点击添加',
  企业3D上传提示1: '上传企业的3D展示链接,可提升企业的经营形象,增信企业真实性,有利于获取海量意向订单；',
  企业3D上传提示2: '3D全景仅可发布1个,3D全景一般指的是航拍企业的3D三维图',
  合作伙伴: '合作伙伴',
  合作伙伴上传提示1: '列出自己企业的大客户,上下游供应链合作伙伴,有利于增强企业的实力影响；',
  合作伙伴上传提示2: '最多可添加20家合作企业；',
  添加合作伙伴: '添加合作伙伴',
  合作企业名称: '合作企业名称',
  合作企业logo: '合作企业logo',
  合作企业名不能为空: '合作企业名不能为空',
  // 客户数据
  名片新增被查看: '云展新增被查看',
  今日新增: '今日新增',
  同比: '同比',
  昨日新增: '昨日新增',
  累计新增: '累计新增',
  详细数据分析: '详细数据分析',
  名片新增被转发: '云展新增被转发',
  名片新增被点赞: '云展新增被点赞',
  新增主动分享数: '新增主动分享数',
  我的分享: '我的分享',
  我的分享记录: '我的分享记录',
  我的分享来源: '我的分享来源',
  我的分享次数: '我的分享次数',
  我的分享时间: '我的分享时间',
  查看详细数据分析: '查看详细数据分析',
  被转发详细数据分析: '被转发详细数据分析',
  被点赞详细数据分析: '被点赞详细数据分析',
  主动分享详细数据分析: '主动分享详细数据分析',
  所属的子账号: '所属的子账号',
  详情: '详情',
  次数: '次数',
  平均时长: '平均时长',
  次: '次',
  '次(多次)': '次',
  '分钟/次': '分钟/次',
  '次数/平均时长': '次数/平均时长',
  企业3D全景: '企业3D全景',
  资讯: '资讯',
  小时: 'h',
  时: 'h',
  分: 'min',
  秒: 's',
  // 中文环境不使用
  今日数据汇总: '今日数据汇总',
  昨日数据汇总: '昨日数据汇总',
  近7日数据汇总: '昨日数据汇总',
  近30日数据汇总: '昨日数据汇总',
  近90日数据汇总: '近90日数据汇总',
  截止昨日数据汇总: '截止昨日数据汇总',
  // 子账号
  添加子账号的说明: '添加已注册的用户成为子账号,前提条件该账号已注册,且未申请认证成为其他企业角色',
  子账号索取验证码说明: '请向所输入子账号的用户索取验证码,确保其已与您确认成为子账号',
  一键生成子账号: '一键生成子账号',
  手动生成子账号: '手动生成子账号',
  企业子账号: '企业子账号',
  状态: '状态',
  子账号状态: '子账号状态',
  正常: '正常',
  锁定: '锁定',
  禁用: '禁用',
  账号: '账号',
  请输入完整子账号搜索: '请输入完整子账号搜索',
  客户列表: '客户列表',
  企业已获取的客户: '企业已获取的客户',
  企业已获取的客户提示: '同一个企业下，多位员工分享给同一个客户时，该客户只能被一个员工子账号绑定！',
  绑定状态: '绑定状态',
  未绑定: '未绑定',
  已绑定: '已绑定',
  请输入公司名称: '请输入公司名称',
  子账号创建成功: '子账号创建成功',
  添加子账号: '添加子账号',
  请输入云展动力账号: '请输入云展动力账号',
  '请输入已注册的手机号/邮箱': '请输入已注册的手机号/邮箱',
  发送验证码: '发送验证码',
  验证码: '验证码',
  新密码不能为空: '新密码不能为空！',
  用户名: '用户名',
  首次绑定时间: '首次绑定时间',
  所属人: '所属人',
  子账号类型: '生成类型',
  创建时间: '创建时间',
  生成时间: '生成时间',
  绑定客户数: '绑定客户数',
  '请填写账号,再发送验证码': '请填写账号,再发送验证码',
  云展动力账号不能为空: '云展动力账号不能为空！',
  验证码不能为空: '验证码不能为空！',

  完善分: '完善分',
  我的名片: '我的名片',
  企业云展系统: '企业云展系统',
  累计客户查看: '累计客户查看',
  累计客户转发: '累计客户转发',
  累计客户点赞: '累计客户点赞',
  昨天新增: '昨天新增',
  去邀请: '去邀请',
  去邀约: '去邀约',
  去查看: '去查看',
  查看企业云展: '查看企业云展',
  企业客户数据概况: '企业客户数据概况',
  我的客户数据概况: '我的客户数据概况',
  快捷服务: '快捷服务',
  邀请员工: '邀请员工',
  同事通过点击链接可以加入企业: '同事通过点击链接可以加入企业',
  新增客户查看: '新增客户查看',
  新增客户转发: '新增客户转发',
  新增客户点赞: '新增客户点赞',
  未跟进客户: '未跟进客户',
  已跟进客户: '已跟进客户',
  员工管理: '员工管理',
  跟进状态: '跟进状态',
  已跟进: '已跟进',
  未跟进: '未跟进',
  '请搜索客户名称/公司名称': '请搜索客户名称/公司名称',

  // 2021/4/22 企业云展改版
  客户: '客户',
  IP地址: 'IP地址',
  客户数据Top10: '客户数据 Top 10',
  客户查看: '客户查看',
  客户转发: '客户转发',
  客户点赞: '客户点赞',
  主动分享: '主动分享',
  我的分享营销: '我的分享营销',
  '员工(或管理者)': '员工(或管理者)',
  客户数: '客户数',
  明细: '明细',
  今天: '今天',
  昨天: '昨天',
  近7天: '近7天',
  近30天: '近30天',
  近90天: '近90天',
  数据汇总: '数据汇总',
  所有数据明细: '所有数据明细',
  员工分享: '员工分享',
  员工获客数: '员工获客数',
  员工获客数TOP10: '员工获客数 TOP 10',
  '暂无数据，不如主动出击，立即去分享~': '暂无数据，不如主动出击，立即去分享~',
  员工的客户查看数: '员工的客户查看数',
  员工的客户转发: '员工的客户转发',
  员工的客户点赞: '员工的客户点赞',
  // 员工分享: '员工分享',
  客户点赞累计: '客户点赞累计',
  员工明细数据: '员工明细数据',
  查看所有员工明细数据: '查看所有员工明细数据',
  员工数据累计排行榜Top10: '员工数据累计排行榜Top10',
  '员工明细数据,单位：次数': '员工明细数据,单位：次数',
  截至: '截至',
  客户的设备终端来源: '客户的设备终端来源',
  员工已联系客户: '员工已联系客户',
  客户查看排行榜Top10: '客户查看排行榜 Top 10',
  客户转发排行榜Top10: '客户转发排行榜 Top 10',
  员工营销数据排行榜Top10: '员工营销数据排行榜 Top 10',
  客户点赞排行榜Top10: '客户点赞排行榜 Top 10',
  客户主动查看列表: '客户主动查看列表',
  客户主动分享列表: '客户主动分享列表',
  '员工（或管理者）': '主动员工（或管理者）',
  客户主动点赞列表: '客户主动点赞列表',
  '主动员工（或管理者）分享列表': '主动员工（或管理者）分享列表',
  '所属员工（主账号/子账号）': '所属员工（主账号/子账号）',
  '指的是企业的员工主动转发分享企业云展系统相关联内容的次数。':
    '指的是企业的员工主动转发分享企业云展系统相关联内容的次数。',
  '指的是企业云展系统相关联内容被非本企业的员工转发分享出去的次数。':
    '指的是企业云展系统相关联内容被非本企业的员工转发分享出去的次数。',
  '指的是企业云展系统相关联内容被非本企业的员工查看的次数。':
    '指的是企业云展系统相关联内容被非本企业的员工查看的次数。',
  '指的是企业云展系统相关联内容被非本企业的员工点赞的次数。':
    '指的是企业云展系统相关联内容被非本企业的员工点赞的次数。',
  '搜索 员工用户名/子账号': '搜索 员工用户名/子账号',
  '搜索 客户用户名': '搜索 客户用户名',
  查看详情: '查看详情',
  转发详情: '转发详情',
  点赞详情: '点赞详情',
  个人名片: '个人云展',
  Ta的个人名片: 'Ta的个人云展',
  注意: '注意',

  招聘地区: '招聘地区',
  工作经验: '工作经验',
  学历: '学历',
  云招聘: '云招聘',
  企业数据统计: '企业数据统计',
  客户数据统计: '客户数据统计',
  潜在客户数据统计: '潜在客户数据统计TOP10',
  '企业云展系统完善度越高,曝光率权重越高,赶紧去完善吧！': '企业云展系统完善度越高,曝光率权重越高,赶紧去完善吧！',
  分享来源: '分享来源',
  分享次数: '分享次数',
  分享时间: '分享时间',
  搜索客户名: '搜索客户名',
  Ta的企业云展系统: 'Ta的企业云展系统',
  查看记录: '查看记录',
  点赞记录: '点赞记录',
  转发记录: '转发记录',
  '您可以设置招聘顺序,数字越大越靠前,在您的企业云展系统则优先排序数字越大的招聘':
    '您可以设置招聘顺序,数字越大越靠前,在您的企业云展系统则优先排序数字越大的招聘',
  发布招聘: '发布招聘',
  职位名称: '职位名称',
  职位ID: '职位ID',
  已应聘人数: '已应聘人数',
  自动生成: '自动生成',
  默认: '默认',
  一键复制: '一键复制',
  申请记录: '申请记录',
  立刻使用: '立刻使用',
  请填写真实姓名: '请填写真实姓名',
  请填写职位名称: '请填写职位名称',
  添加照片: '添加照片',
  公司名: '公司名',
  企业简称不能为空: '企业简称不能为空',
  投资比例不能为空: '投资比例不能为空',
  认缴金额不能为空: '认缴金额不能为空',
  企业简称: '企业简称',
  请输入企业简称: '请输入企业简称',
  企业英文简称: '企业英文简称',
  请输入企业英文简称: '请输入企业英文简称',
  是否对外显示: '是否对外显示',
  不显示: '不显示',
  添加投资机构: '添加投资机构',
  添加手机号邮箱: '添加手机号邮箱',
  '手机号&邮箱': '手机号&邮箱',
  企业二维码: '企业二维码',
  同事通过扫二维码可以加入企业: '同事通过扫二维码可以加入企业',
  复制图片: '复制图片',
  企业链接: '企业链接',

  添加企业员工: '添加企业员工',
  暂时不用: '暂时不用',
  马上升级: '马上升级',
  '套餐子账号已达上限,请升级套餐！': '套餐子账号已达上限,请升级套餐！',
  '子账号指的是你在企业的同事,你作为企业的管理者,有权向你企业的同事发出邀请其加入你的企业,共同为企业贡献更多力量':
    '子账号指的是你在企业的同事,你作为企业的管理者,有权向你企业的同事发出邀请其加入你的企业,共同为企业贡献更多力量',
  添加对外投资: '添加对外投资',

  离职交接: '离职交接',
  交接人手机号: '交接人手机号',
  请输入未注册手机号: '请输入未注册手机号',
  离职交接提示: '提示：保存后该账号的数据将继承到新号中',

  标签列表: '标签列表',

  '3步带你快速获客': '3步带你快速获客',
  创建我的名片: '创建我的名片',
  '一键发送,人脉裂变': '一键发送,人脉裂变',
  创建企业云展系统: '创建企业云展系统',
  '打造元宇宙企业,引爆百万客流': '打造元宇宙企业,引爆百万客流',
  更多进阶操作: '更多进阶操作',
  快速了解平台功能: '快速了解平台功能',
  待企业认证: '待企业认证',
  '完成企业认证，享受更优服务，去认证 >': '完成企业认证，享受更优服务，去认证 >',
  立即认证: '立即认证',
}
